import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import Shortcuts from "./Shortcuts";
import Tutorial from "../../Tutorial";

import { IProps } from "./interfaces";
import messages from "./messages";

const ScoreTutorial = ({ close }: IProps) => (
    <Tutorial close={close} title={<FormattedMessage {...messages.title} />}>
        {[
            {
                title: <FormattedMessage {...messages.title1} />,
                content: <FormattedHTMLMessage {...messages.description1} />,
            },
            {
                title: <FormattedMessage {...messages.title2} />,
                content: <FormattedHTMLMessage {...messages.description2} />,
            },
            {
                title: <FormattedMessage {...messages.title3} />,
                content: <FormattedHTMLMessage {...messages.description3} />,
            },
            {
                title: <FormattedMessage {...messages.title4} />,
                content: <FormattedHTMLMessage {...messages.description4} />,
            },
            {
                title: <FormattedMessage {...messages.title5} />,
                content: <FormattedHTMLMessage {...messages.description5} />,
            },
            {
                title: <FormattedMessage {...messages.title6} />,
                content: <FormattedHTMLMessage {...messages.description6} />,
            },
            {
                title: <FormattedMessage {...messages.title7} />,
                content: <Shortcuts />,
            },
        ]}
    </Tutorial>
);

export default ScoreTutorial;
